'use strict';

/**
 * Collection of scripts related with the select component.
 */
var select = {};

// Model Includes
var SelectModel = require('../model/select');

// Constants
var ATTRIBUTES = {
    DATA: {
        ID: 'data-select-id',
        IS_LOADED: 'data-is-select-loaded',
        IS_SELECT: 'data-is-select',
        OPTIONS: 'data-select-options'
    }
};

/**
 * Initialize all select components that are not already initialized.
 *  1. Use select model to create an object instance based on an HTML select element;
 *  2. Use model.initSelect2 function to convert a normal select into a select2 select;
 *  3. Add the new select to the list of initialized selects window.comCustomSelects.
 * @param {null | undefined | JQuery<HTMLElement>} _$selects - initialize selects. If non is provider, then it will initialize all selects.
 */
select.init = function (_$selects) {
    // Constants
    var $selects = $(
        `[${ATTRIBUTES.DATA.IS_SELECT}=true]:not([${ATTRIBUTES.DATA.IS_LOADED}=true])`
    );

    // Get custom selects to initialize
    if (_$selects !== null && _$selects !== undefined && _$selects.length) {
        $selects = _$selects;
    }

    // Initialize window global variable that stores all custom selects active in page
    if (
        !('comCustomSelects' in window) ||
        !Array.isArray(window.comCustomSelects)
    ) {
        window.comCustomSelects = [];
    }

    $selects.each(function (index, element) {
        // Constants
        const $ELEMENT = $(element);
        const ID = $ELEMENT.attr(ATTRIBUTES.DATA.ID);
        const OPTIONS = $ELEMENT.attr(ATTRIBUTES.DATA.OPTIONS);

        // Create a new DatePicker instance
        const MODEL = new SelectModel(
            $ELEMENT,
            ID,
            OPTIONS !== null &&
            OPTIONS !== undefined &&
            OPTIONS !== 'null' &&
            OPTIONS !== 'undefined'
                ? OPTIONS
                : undefined
        );

        MODEL.initSelect2();
        window.comCustomSelects.push(MODEL);
        $ELEMENT.attr(ATTRIBUTES.DATA.IS_LOADED, 'true');
    });
};

/**
 * Attach a collection of event listeners related with select components.
 */
select.attachEventListeners = function () {
    $('body').on('com:initSelects', function () {
        select.init();
    });
};

/**
 * Set a collection of custom static JQuery functions.
 */
select.setJQueryStatic = function () {
    /**
     * Initialize all select components that are not already initialized.
     * @param {null | undefined | JQuery<HTMLElement>} _$selects - initialize selects. If non is provider, then it will initialize all selects.
     */
    $.initCustomSelects = function (_$selects) {
        select.init(_$selects);
    };
};

module.exports = select;
